import { ADD_ABORTABLE_REQUEST, REMOVE_ABORTABLE_REQUEST } from './api.actions';

const initialState = {
  abortableRequests: [],
};

export const apiReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_ABORTABLE_REQUEST: {
      return {
        ...state,
        abortableRequests: [...state.abortableRequests, payload],
      };
    }
    case REMOVE_ABORTABLE_REQUEST: {
      const payloadItemIndex = state.abortableRequests.findIndex((el) => el.name === payload.name);

      return {
        ...state,
        abortableRequests: [
          ...state.abortableRequests.slice(0, payloadItemIndex),
          ...state.abortableRequests.slice(payloadItemIndex + 1),
        ],
      };
    }
    default: {
      return state;
    }
  }
};
